import { ReactNode } from "react";
import { Bubble, BubbleContent } from "@libs/zapi-ui/ds/components/bubble";
import { Message, MessageAvatar, MessageContent } from "@libs/zapi-ui/ds/components/message";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { AvatarAi } from "./AvatarAi";
import { useChatAppearance } from "./ChatAppearance";
import { LeoAvatar } from "./LeoAvatar";

type TAiMessageProps = {
  state?: "default" | "error";
  avatarVariant?: "filled" | "outlined";
  children: ReactNode;
  className?: string;
};

export function AiMessage({ state = "default", avatarVariant = "filled", children, className }: TAiMessageProps) {
  const appearance = useChatAppearance();
  if (appearance === "leo")
    return (
      <Message className={className}>
        <MessageAvatar className="self-start bg-transparent">
          <LeoAvatar className={cn(state === "error" && "text-destructive")} />
        </MessageAvatar>
        <MessageContent>
          <Bubble variant="ghost">
            <BubbleContent className="typo-body-sm flex flex-col items-start gap-2 pt-1">{children}</BubbleContent>
          </Bubble>
        </MessageContent>
      </Message>
    );

  return (
    <div className={cn("flex w-full min-w-0 items-start gap-3 bg-transparent py-3", className)}>
      <AvatarAi state={state} variant={avatarVariant} />
      <div className="flex min-w-0 flex-1 flex-col items-start justify-center gap-2.5 py-1">{children}</div>
    </div>
  );
}
